import { type UserSession } from '@solinkcorp/authentication';

export function getDateByMetadataProp(
  user: UserSession,
  property: 'videoPlaybackStartsAt' | 'videoPlaybackEndsAt',
): Date | undefined {
  // ISO String
  const dateStr = user.profile.metadata?.[property] as string | undefined;

  if (dateStr) {
    const videoPlaybackStartsAtDate = new Date(dateStr);
    if (!isNaN(videoPlaybackStartsAtDate.valueOf())) {
      return videoPlaybackStartsAtDate;
    }
  }

  return undefined;
}
